import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function StateBox({ kind = 'empty', title, children }) {
    return (_jsxs("div", { className: cx('statebox', kind === 'error' && 'err'), role: kind === 'error' ? 'alert' : 'status', "aria-busy": kind === 'loading' ? true : undefined, children: [_jsx("div", { className: "si", children: kind }), title && _jsx("div", { className: "st", children: title }), children] }));
}
//# sourceMappingURL=StateBox.js.map